<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content>
    <h1 class="header">Create New Team</h1>
    <table>
        <tr>
            <th id="manager">Manager:</th>
            <td>
                <mat-form-field appearance="outline">
                    <input matInput [(ngModel)]="manager" required (ngModelChange)="onAddMemberChanged()"/>
                    <div *ngIf="peopleSearchResults.length > 0" class="search-results">
                        <div *ngFor="let model of peopleSearchResults" class="row-search-results-row">

                            <mat-card class="search-results-item"
                                      (click)="personSelected(model)"
                                      (keyup)="personSelected(model)">
                                <mat-card-header>
                                    <img mat-card-avatar class="example-header-image"
                                         src="{{getPhoto(model.gmin)}}"
                                         width="auto"
                                         height="auto"
                                         alt=""
                                         (error)="displayDefaultImage($event)"/>
                                    <mat-card-subtitle
                                            class="display-name-header">{{model.displayName}}</mat-card-subtitle>
                                    <mat-card-subtitle>{{model.positionTitle}}</mat-card-subtitle>
                                </mat-card-header>
                            </mat-card>
                        </div>
                    </div>
                </mat-form-field>

            </td>
        </tr>
        <tr>
            <th id="alt-manager">Alternate Manager:</th>
            <td>
                <mat-form-field appearance="outline">
                    <input matInput [(ngModel)]="alternateManager" required (ngModelChange)="onAddAltMemberChanged()"/>
                    <div *ngIf="altSearchResults.length > 0" class="search-results">
                        <div *ngFor="let model of altSearchResults" class="row-search-results-row">

                            <mat-card class="search-results-item"
                                      (click)="altPersonSelected(model)"
                                      (keyup)="altPersonSelected(model)">
                                <mat-card-header>
                                    <img mat-card-avatar class="example-header-image"
                                         src="{{getPhoto(model.gmin)}}"
                                         width="auto"
                                         height="auto"
                                         alt=""
                                         (error)="displayDefaultImage($event)"/>
                                    <mat-card-subtitle
                                            class="display-name-header">{{model.displayName}}</mat-card-subtitle>
                                    <mat-card-subtitle>{{model.positionTitle}}</mat-card-subtitle>
                                </mat-card-header>
                            </mat-card>
                        </div>
                    </div>
                </mat-form-field>
            </td>
        </tr>
    </table>
    <form fxLayout="column" fxLayoutAlign="center" (ngSubmit)="submitForm()" #form="ngForm">
        <table>
            <tr>
                <th id="team-name">Team Name:</th>
                <td>
                    <mat-form-field appearance="outline">
                        <input matInput required id="firstName" [(ngModel)]="teamDetails.teamName" name="teamName"/>
                    </mat-form-field>
                </td>
            </tr>
        </table>
        <button mat-raised-button color="primary" [disabled]="!form.form.valid">Submit</button>
    </form>
</mat-dialog-content>
